import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
    selector: 'app-timeout',
    templateUrl: './timeout.component.html',
    styleUrl: './timeout.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TimeoutComponent {

}
